import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './css/Summary.scss';
import LabelDownload from '../../order/components/LabelDownload';

@injectIntl
export default class Summary extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        order: PropTypes.object,
    }

    render() {
        const {order} = this.props;
        const {formatMessage} = this.props.intl;

        const service = order.get('service');
        const region = order.get('region');
        const img = service ? service.getIn(['image', 'path']) : null;

        const requiresLabel = !!order.getIn(['labelStatus', 'required'], false);

        return (
            <div>
                <h3>
                    <FormattedMessage id='frontend.orders_detail.headline.summary'/>
                </h3>
                <ul className={styles.list}>
                    <li>
                        <span className={styles.itemHeader}>
                            <FormattedMessage id='frontend.orders_detail.label.region'/>
                        </span>
                        <span className={styles.region}>
                            <abbr title={formatMessage({id: region.get('alias')})}>{region.get('isoCode')}</abbr>
                        </span>
                    </li>
                    <li>
                        <span className={styles.itemHeader}>
                            <FormattedMessage id={service.get('alias')}/>
                        </span>
                        <span>
                            {img ? <img src={`/${img}`} role='presentation' className={styles.service}/> : null}
                        </span>
                    </li>
                    {(requiresLabel && <li>
                        <span className={styles.itemHeader}>
                            <FormattedMessage id='frontend.orders_detail.button.label_button'/>
                        </span>
                        <span>
                            <LabelDownload order={order} size='small'/>
                        </span>
                    </li>)}
                </ul>
            </div>
        );
    }
}
